// extracted by mini-css-extract-plugin
export default {"emptyTable":"EmptyText_emptyTable__FYIT4","emptyText":"EmptyText_emptyText__+jBtp","resetButtonText":"EmptyText_resetButtonText__Snhkh"};